import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { AiFillGift } from "react-icons/ai";
import { getGiftStoryLink, sendGiftStoryEmails, getUser } from "../../helper/api";
import { ReactMultiEmail, isEmail } from "react-multi-email";
import "./gift-story-button.m.css";
import assetify from "@quintype/framework/assetify";
import giftArt from "../../../../assets/images/nl-images/nl-sena-page.png";
import { Modal } from "../modal";
import { Button } from "../../atoms/button";
import { Link } from "@quintype/components";

const initialState = {
  modal: false,
  data: { token: "", numberOfLinksGeneratedTillNow: 0, limit: 0 },
  loading: false
};

export function GiftStoryButton({ story }) {
  console.log(story);
  const inputRef = useRef(null);
  const [copied, setCopied] = useState(false);
  const [emails, setEmails] = useState([]);
  const [emailHandlerState, setEmailHandlerState] = useState({ text: "Send Gift Email", loading: false });
  const [gift, setGift] = useState(initialState);
  const [tab, setTab] = useState(1);

  const getGiftLink = async () => {
    try {
      setGift({ ...gift, loading: true });
      const result = await getGiftStoryLink({
        storySlug: story.slug,
        storyId: story.id
      });
      setGift(state => ({ ...state, data: result, loading: false, modal: true }));
    } catch (e) {
      setGift(state => ({ ...state, loading: false }));
    }
  };

  const sendGiftEmails = async () => {
    try {
      if (emails.length > 0 && emailHandlerState.text === "Send Gift Email") {
        const { member } = await getUser();
        const gifterEmail = member.email;
        const authors = story["author-name"];
        const { msg } = await sendGiftStoryEmails({
          gifterEmail: gifterEmail,
          authors: authors,
          emails: emails,
          storyLink: storyURL,
          storyTitle: story.headline,
          storySub: story.subheadline
        });
        if (msg === "ok") {
          setEmailHandlerState({ ...emailHandlerState, text: "Emails Sent!" });
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const storyURL = gift.data.token ? story.url + "?token=" + gift.data.token : "";
  const tokenGranted = gift.data.token;

  return (
    <div>
      {gift.modal ? (
        <Modal
          onBackdropClick={() => {
            setGift(initialState);
            setCopied(false);
          }}
        >
          {tab === 1 && (
            <div styleName="text-center" style={{ marginTop: "3rem", padding: "0 1rem" }}>
              {tokenGranted ? <h1>Gift link generated</h1> : null}

              <img
                width="300px"
                styleName="gift-story-artwork"
                src={assetify(giftArt)}
                alt="gift story success artwork"
              />
              <div styleName="link-wrapper mt-1 text-center">
                <div style={{ color: "var(--gray)" }}>
                  {tokenGranted
                    ? `You have ${gift.data.limit -
                        gift.data.numberOfLinksGeneratedTillNow} more stories to gift this month.`
                    : "You have no more stories to gift this month."}
                </div>
                {tokenGranted ? (
                  <div styleName="link-wrapper">
                    <h5 styleName="mt-1">Copy the link below and share it!</h5>
                    <div styleName="link-url-input">
                      <input type={"text"} value={storyURL} readOnly ref={inputRef} styleName="mt-1" />
                    </div>
                    <Button
                      onClick={() => {
                        inputRef.current.select();
                        document.execCommand("copy");
                        setCopied(true);
                      }}
                    >
                      {copied ? "Copied" : "Copy link"}
                    </Button>
                    <Button style={{ marginTop: "1rem" }} onClick={() => setTab(2)}>
                      Email link instead
                    </Button>
                  </div>
                ) : null}

                <div styleName="link-wrapper" style={{ marginTop: "1.5rem" }}>
                  <h5>
                    <small>Would you like to gift a subscription instead?</small>
                  </h5>
                  <div style={{ marginTop: "0.5rem" }}>
                    <Link href={`/subscription?tab=gift-subscription`}>
                      <Button>Gift a subscription</Button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          )}
          {tab === 2 && (
            <div styleName="text-center" style={{ marginTop: "3rem", padding: "0 1rem" }}>
              {tokenGranted ? <h1>Gift this story</h1> : null}

              <img
                width="300px"
                styleName="gift-story-artwork"
                src={assetify(giftArt)}
                alt="gift story success artwork"
              />
              <div styleName="link-wrapper mt-1 text-center">
                <div style={{ color: "var(--gray)" }}>
                  {tokenGranted
                    ? `You have ${gift.data.limit -
                        gift.data.numberOfLinksGeneratedTillNow} more stories to gift this month.`
                    : "You have no more stories to gift this month."}
                </div>
                {tokenGranted ? (
                  <div styleName="link-wrapper">
                    {/* <h5 styleName="mt-1">Enter upto 3 Emails to gift</h5> */}
                    <div styleName="link-url-input">
                      <ReactMultiEmail
                        placeholder="You can add upto 3 emails"
                        emails={emails}
                        onChange={em => {
                          setEmails(em);
                        }}
                        validateEmail={email => {
                          return isEmail(email); // return boolean
                        }}
                        getLabel={(email, index, removeEmail) => {
                          return (
                            <div data-tag key={index}>
                              {email}
                              <span data-tag-handle onClick={() => removeEmail(index)}>
                                ×
                              </span>
                            </div>
                          );
                        }}
                      />
                    </div>
                    <Button onClick={sendGiftEmails}>{emailHandlerState.text}</Button>
                    <Button style={{ marginTop: "1rem" }} onClick={() => setTab(1)}>
                      Copy link instead
                    </Button>
                  </div>
                ) : null}

                <div styleName="link-wrapper" style={{ marginTop: "1.5rem" }}>
                  <h5>
                    <small>Would you like to gift a subscription instead?</small>
                  </h5>
                  <div style={{ marginTop: "0.5rem" }}>
                    <Link href={`/subscription?tab=gift-subscription`}>
                      <Button>Gift a subscription</Button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>
      ) : null}

      <div>
        <button disabled={gift.loading} styleName="gift-btn" className="gift-btn" onClick={getGiftLink}>
          <AiFillGift styleName="gift-btn__icon" className="gift-btn__icon" />
          <span styleName="gift-btn__text" className="gift-btn__text">
            {gift.loading ? "Loading..." : "Gift Story"}
          </span>
        </button>
      </div>
    </div>
  );
}

GiftStoryButton.propTypes = {
  story: PropTypes.object,
  member: PropTypes.object
};
